import { LinkOutlined, SettingOutlined } from "@ant-design/icons";
import { useQuery } from "@apollo/client";
import { AbiCoder } from "@ethersproject/abi";
import { Contract } from "@ethersproject/contracts";
import { abis, addresses } from "@my-app/contracts";
import { useContractFunction, useEthers } from "@usedapp/core";
import { Form, Radio, Select, Switch } from "antd";
import Meta from "antd/lib/card/Meta";
import { ethers } from "ethers";
import React, { useEffect, useState } from "react";
import {
  CreateButton,
  CreateCard,
  FormInput,
  FormSelect,
  FormTitle,
  ListDiv,
  ListHeading,
  ListTitle,
  MainDiv,
  MainModal,
  ModalSubTitle,
  ModalTitle,
  RadioItem,
  SelectOption,
  ModalOption,
  Button,
} from "../../components";
import { CHAINS, protocolModules } from "../../constants";
import { GET_USER_EPOCH_WALLETS } from "../../graphql/subgraph";
import Tutorial from "../Tutorial";
import ens from "../../assets/ens.png";

const CreateJob = () => {
  const { library, account, chainId } = useEthers();
  console.log("chainId: ", chainId);

  const [componentSize, setComponentSize] = useState("default");
  const [name, setName] = useState(
    "Job " + Math.floor(Math.random() * 1000).toString()
  );
  const [scWallet, setScWallet] = useState(true);
  const [jobType, setJobType] = useState("0");
  const [executionInterval, setExecutionInterval] = useState(3600);
  const [strictExecution, setStrictExecution] = useState(false);
  const [reccurring, setReccurring] = useState(true);
  const [contractAddress, setContractAddress] = useState("");
  const [contractABI, setContractABI] = useState(null);
  const [contractInstance, setContractInstance] = useState(null);
  const [contractAction, setContractAction] = useState("");
  const [executionData, setExecutionData] = useState("0x");
  const [isModalVisible, setIsModalVisible] = useState(false);

  const [aaveToken, setAAVEToken] = useState("");
  const [aaveAmount, setAAVEAmount] = useState("");

  const [uniswapToken1, setUniswapToken1] = useState(
    "0x9c3C9283D3e44854697Cd22D3Faa240Cfb032889"
  );
  const [uniswapToken2, setUniswapToken2] = useState(
    "0xA6FA4fB5f76172d178d61B04b0ecd319C5d1C0aa"
  );
  const [uniswapAmount, setUniswapAmount] = useState("1");

  const { loading, error, data: userEpochWalletData } = useQuery(
    GET_USER_EPOCH_WALLETS,
    {
      variables: { id: account?.toLowerCase() },
    }
  );
  const [selectedProtocolJob, setSelectedProtocolJob] = useState(null);

  let contract = new Contract(addresses[chainId ? chainId: CHAINS.Mumbai.chainId].epochBase, abis.epochBase, library);
  const { state, send } = useContractFunction(contract, "addJob", {
    transactionName: "AddJob",
  });

  const {
    state: stateAddModuleParams,
    send: sendAddModuleParams,
  } = useContractFunction(
    userEpochWalletData?.userEntity
      ? new Contract(
          userEpochWalletData?.userEntity?.activeWallet.walletAddress,
          abis.epochWallet,
          library
        )
      : null,
    "addModuleParams",
    {
      transactionName: "AddModuleParams",
    }
  );
  console.log("stateAddModuleParams: ", stateAddModuleParams);

  const {
    state: stateAddProtocolJob,
    send: sendAddProtocolJob,
  } = useContractFunction(
    userEpochWalletData?.userEntity
      ? new Contract(
          userEpochWalletData?.userEntity?.activeWallet.walletAddress,
          abis.epochWallet,
          library
        )
      : null,
    "addJob",
    {
      transactionName: "AddJob",
    }
  );

  const showModal = () => {
    setIsModalVisible(true);
  };

  const hideModal = () => {
    setIsModalVisible(false);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const onFormLayoutChange = (data) => {
    console.log("data: ", data);
  };

  const createJob = async () => {
    console.log("name: ", name);
    console.log("scWallet: ", scWallet);
    console.log("jobType: ", jobType);
    console.log("executionInterval: ", executionInterval);
    console.log("strictExecution: ", strictExecution);
    console.log("reccurring: ", reccurring);
    console.log("contractAddress: ", contractAddress);
    console.log("contractAction: ", contract.interface.getSighash("addJob"));
    console.log("executionData: ", executionData);

    let _name = name;
    let _isSmartContractWallet = scWallet;
    let _jobType = parseInt(jobType);
    let _initTimestamp = Math.floor(new Date() / 1000);
    let _executionInterval = executionInterval;
    let _strictExecution = strictExecution;
    let _runOnce = !reccurring;

    let executionContract = contractAddress;
    let functionSignature = contractAction;
    let data = executionData;

    if (parseInt(jobType) === 0) {
      const abiCoder = new ethers.utils.AbiCoder();

      let depositAmount;
      let tokenAddress;
      let encodedParams;
      let moduleAddress;

      if (selectedProtocolJob === protocolModules.aaveDepositSIP.name) {
        depositAmount = ethers.utils.parseEther(aaveAmount);
        tokenAddress = [aaveToken];
        encodedParams = abiCoder.encode(
          ["uint256", "address"],
          [depositAmount.toString(), aaveToken]
        );
        moduleAddress = addresses[chainId ? chainId: CHAINS.Mumbai.chainId].aaveModule;
      }

      if (selectedProtocolJob === protocolModules.uniswapSwapSIP.name) {
        depositAmount = ethers.utils.parseEther(uniswapAmount);
        tokenAddress = [uniswapToken1, uniswapToken2];
        encodedParams = abiCoder.encode(
          ["uint256", "address", "address"],
          [depositAmount.toString(), uniswapToken1, uniswapToken2]
        );
        moduleAddress = addresses[chainId ? chainId: CHAINS.Mumbai.chainId].uniswapV2Module;
      }

      console.log("depositAmount: ", depositAmount);
      console.log("tokenAddress: ", tokenAddress);
      console.log("encodedParams: ", encodedParams);

      await sendAddProtocolJob(
        _name,
        tokenAddress,
        true,
        _jobType,
        _executionInterval,
        _strictExecution,
        _runOnce,
        executionContract,
        functionSignature,
        encodedParams,
        moduleAddress
      );
    } else {
      console.log("Hererere");
      console.log("_name: ", _name);
      console.log("_isSmartContractWallet: ", _isSmartContractWallet);
      console.log("_jobType: ", _jobType);
      console.log("_initTimestamp: ", _initTimestamp);
      console.log("_executionInterval: ", _executionInterval);
      console.log("_strictExecution: ", _strictExecution);
      console.log("_runOnce: ", _runOnce);
      console.log("executionContract: ", executionContract);
      console.log("functionSignature: ", functionSignature);
      console.log("data: ", data);

      const abiCoder = new AbiCoder();
      const jobInfo = abiCoder.encode(
        ["string", "bool", "uint256", "uint256", "uint256", "bool", "bool"],
        [
          _name,
          _isSmartContractWallet,
          _jobType,
          _initTimestamp,
          _executionInterval,
          _strictExecution,
          _runOnce,
        ]
      );
      const jobParam = abiCoder.encode(
        ["address[]", "address", "bytes4", "bytes"],
        [[], executionContract, functionSignature, data]
      );

      await send(jobInfo, jobParam);
    }
  };

  useEffect(() => {
    console.log(state);
  }, [state]);

  useEffect(() => {
    console.log("contractABI: ", contractABI);
    console.log("contractAddress: ", contractAddress);
    if (contractAddress === "" || contractABI === null) {
      return;
    }
    console.log("Creating contract");
    const contract = new Contract(contractAddress, contractABI);
    setContractInstance(contract);
  }, [contractABI, contractAddress]);

  // useEffect(() => {
  //   let epochWalletContract = setEpochWalletContract(epochWalletContract);
  // }, [userEpochWalletData?.userEntity?.activeWallet.walletAddress]);

  return (
    <>
      <MainDiv>
        <ListHeading>Create Job</ListHeading>
        <ListDiv>
          <Form
            layout="vertical"
            initialValues={{}}
            onValuesChange={onFormLayoutChange}
            size={componentSize}
          >
            <FormTitle label="Name">
              <FormInput
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                }}
              />
            </FormTitle>
            {/* <FormTitle label="Form Size" name="size">
          <Radio.Group>
            <Radio.Button value="small">Small</Radio.Button>
            <Radio.Button value="default">Default</Radio.Button>
            <Radio.Button value="large">Large</Radio.Button>
          </Radio.Group>
        </FormTitle> */}
            <FormTitle label="Use Epoch Wallet" valuePropName="checked">
              <Switch
                onChange={(e) => {
                  setScWallet(e);
                }}
                checked={scWallet}
              />
            </FormTitle>
            <FormTitle label="Job Type">
              <Radio.Group
                onChange={(e) => {
                  setJobType(e.target.value);
                }}
                value={jobType}
              >
                <RadioItem value="1">Arbitrary Job</RadioItem>
                <RadioItem value="0" style={{ marginLeft: "6rem" }}>
                  Protocol Job
                </RadioItem>
              </Radio.Group>
            </FormTitle>
            {parseInt(jobType) === 1 ? (
              <>
                <FormTitle label="Contract ABI">
                  <FormInput
                    onChange={(e) => {
                      setContractABI(e.target.value);
                    }}
                    value={contractABI}
                  />
                </FormTitle>
                <FormTitle label="Contract Address">
                  <FormInput
                    onChange={(e) => {
                      setContractAddress(e.target.value);
                    }}
                    value={contractAddress.toString()}
                  />
                </FormTitle>
                {contractAddress && contractABI && contractInstance ? (
                  <FormTitle label="Contract Action">
                    <FormSelect
                      onChange={(e) => {
                        console.log("e: ", e);
                        setContractAction(e);
                      }}
                    >
                      {Object.keys(contractInstance.interface.functions).map(
                        (func) => (
                          <SelectOption
                            value={contractInstance.interface.getSighash(
                              contractInstance.interface.functions[
                                func.toString()
                              ].name
                            )}
                          >
                            {func}
                          </SelectOption>
                        )
                      )}
                    </FormSelect>
                  </FormTitle>
                ) : null}
                <FormTitle label="Execution Data">
                  <FormInput
                    onChange={(e) => {
                      setExecutionData(e.target.value);
                    }}
                    value={executionData}
                  />
                </FormTitle>
              </>
            ) : null}
            {parseInt(jobType) === 0 ? (
              <>
                <ListTitle>Select Protocol</ListTitle>{" "}
                <div style={{ display: "flex" }}>
                  <CreateCard
                    style={{
                      width: 200,
                      cursor: "pointer",
                      textAlign: "center",
                    }}
                    cover={
                      <img
                        style={{
                          width: "auto",
                          height: "4rem",
                          textAlign: "center",
                          marginTop: "1rem",
                        }}
                        alt="example"
                        src="https://www.pngall.com/wp-content/uploads/10/Aave-Crypto-Logo-PNG.png"
                      />
                    }
                    hoverable="true"
                    onClick={() => {
                      setContractAddress(
                        addresses[chainId ? chainId: CHAINS.Mumbai.chainId].aaveModule
                      );
                      setContractAction(
                        protocolModules.aaveDepositSIP.contractFunctionSig
                      );
                      setSelectedProtocolJob(
                        protocolModules.aaveDepositSIP.name
                      );
                      setExecutionData("0x");
                    }}
                    actions={[
                      <SettingOutlined onClick={showModal} key="setting" />,
                      <a target="#" href="https://aave.com">
                        <LinkOutlined key="link" />
                      </a>,
                    ]}
                  >
                    <Meta
                      title="AAVE SIP"
                      description="This will deposit or withdraw some tokens to AAVE every month"
                    />
                  </CreateCard>
                  <CreateCard
                    style={{
                      width: 200,
                      cursor: "pointer",
                      marginLeft: "0.5rem",
                      textAlign: "center",
                    }}
                    cover={
                      <img
                        style={{
                          width: "auto",
                          marginTop: "1.5rem",
                          height: "2.5rem",
                          textAlign: "center",
                        }}
                        alt="example"
                        src="https://upload.wikimedia.org/wikipedia/commons/5/5a/Uniswap_Logo_and_Wordmark.svg"
                      />
                    }
                    hoverable="true"
                    onClick={() => {
                      setContractAddress(
                        addresses[chainId ? chainId: CHAINS.Mumbai.chainId].uniswapV2Module
                      );
                      setContractAction(
                        protocolModules.uniswapSwapSIP.contractFunctionSig
                      );
                      setSelectedProtocolJob(
                        protocolModules.uniswapSwapSIP.name
                      );
                      setExecutionData("0x");
                    }}
                    actions={[
                      <SettingOutlined onClick={showModal} key="setting" />,
                      <a target="#" href="https://aave.com">
                        <LinkOutlined key="link" />
                      </a>,
                    ]}
                  >
                    <Meta
                      title="Uniswap Module"
                      description="This will swap certain tokens for you automatically or deposit to LP Pool"
                    />
                  </CreateCard>
                  <CreateCard
                    style={{
                      width: 200,
                      cursor: "pointer",
                      textAlign: "center",
                      marginLeft: "0.5rem",
                    }}
                    cover={
                      <img
                        style={{
                          width: "auto",
                          height: "4rem",
                          textAlign: "center",
                          marginTop: "1rem",
                        }}
                        alt="example"
                        src="data:image/svg+xml;base64,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"
                      />
                    }
                    hoverable="true"
                    onClick={() => {
                      setContractAddress(
                        protocolModules.aaveDepositSIP.contractAddress
                      );
                      setContractAction(
                        protocolModules.aaveDepositSIP.contractFunctionSig
                      );
                      setSelectedProtocolJob(
                        protocolModules.aaveDepositSIP.name
                      );
                      setExecutionData("0x");
                    }}
                    actions={[
                      <SettingOutlined onClick={showModal} key="setting" />,
                      <a target="#" href="https://ens.domains">
                        <LinkOutlined key="link" />
                      </a>,
                    ]}
                  >
                    <Meta
                      title="ENS Domain Renew"
                      description="Automatically renew your ENS Domains every year"
                    />
                  </CreateCard>
                </div>
              </>
            ) : null}

            <FormTitle label="Execution Interval">
              <FormInput
                onChange={(e) => {
                  setExecutionInterval(e.target.value);
                }}
                value={executionInterval}
                type={"number"}
              />
            </FormTitle>
            <div style={{ display: "flex" }}>
              <FormTitle label="Strict Execution" valuePropName="checked">
                <Switch
                  onChange={(e) => {
                    setStrictExecution(e);
                  }}
                  checked={strictExecution}
                />
              </FormTitle>
              <div style={{ marginLeft: "6rem" }}>
                <FormTitle label="Reccurring" valuePropName="checked">
                  <Switch
                    onChange={(e) => {
                      setReccurring(e);
                    }}
                    checked={reccurring}
                  />
                </FormTitle>
              </div>
            </div>
            <div style={{ display: "flex", justifyContent: "end" }}>
              <CreateButton style={{ margin: 0 }} onClick={createJob}>
                Publish Job
              </CreateButton>
            </div>
          </Form>
        </ListDiv>
        <MainModal
          title={null}
          visible={isModalVisible}
          onOk={handleOk}
          onCancel={handleCancel}
          footer={null}
          bodyStyle={{
            backgroundColor: "#130e1b",
            color: "rgb(181 175 195)",
          }}
        >
          <ModalSubTitle>Configure Automation Values</ModalSubTitle>
          {selectedProtocolJob === protocolModules.aaveDepositSIP.name ? (
            <>
              <FormTitle label="Token Address" style={{ marginTop: "1.7rem" }}>
                {/* <FormSelect
                  onChange={(e) => {
                    setAAVEToken(e);
                  }}
                  dropdownStyle={{
                    backgroundColor: "#130e1b",
                    color: "rgb(181 175 195)",
                  }}
                  // style={{ marginLeft: "2.8rem", width: "22.7rem" }}
                >
                  <ModalOption
                    dropdownStyle={{
                      backgroundColor: "#130e1b",
                      color: "rgb(181 175 195)",
                    }}
                    value="0x9c3c9283d3e44854697cd22d3faa240cfb032889"
                  >
                    WMatic
                  </ModalOption>
                </FormSelect> */}
              </FormTitle>
              <FormInput
                onChange={(e) => {
                  setAAVEToken(e.target.value);
                }}
                value={aaveToken}
                type={"text"}
              />
              <FormTitle
                label="SIP Amount"
                style={{ marginTop: "1.5rem" }}
              ></FormTitle>
              <FormInput
                onChange={(e) => {
                  setAAVEAmount(e.target.value);
                }}
                value={aaveAmount}
                type={"number"}
              />
            </>
          ) : null}
          {selectedProtocolJob === protocolModules.uniswapSwapSIP.name ? (
            <>
              <FormTitle
                label="Token Address From"
                style={{ marginTop: "1.7rem" }}
              ></FormTitle>
              <FormInput
                onChange={(e) => {
                  setUniswapToken1(e.target.value);
                }}
                value={uniswapToken1}
                type={"text"}
              />
              <FormTitle
                label="Token Address To"
                style={{ marginTop: "1.7rem" }}
              ></FormTitle>
              <FormInput
                onChange={(e) => {
                  setUniswapToken2(e.target.value);
                }}
                value={uniswapToken2}
                type={"text"}
              />
              <FormTitle
                style={{ marginTop: "1.5rem" }}
                label="Swap Amount"
              ></FormTitle>
              <FormInput
                onChange={(e) => {
                  setUniswapAmount(e.target.value);
                }}
                value={uniswapAmount}
                type={"number"}
              />
            </>
          ) : null}
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              marginTop: "2rem",
            }}
          >
            <Button onClick={hideModal} style={{ margin: 0, height: "2.5rem", paddingTop: "8px" }}>
              Submit
            </Button>
          </div>
        </MainModal>
      </MainDiv>
      <Tutorial />
    </>
  );
};

export default CreateJob;
